import type { BoxCreateInput, BoxInfo } from '@lub0v/santa-utils';

/**
 * `PUT /api/box` replaces the settings it is given, so an update has to carry
 * the box as it stands and change one thing — sending only the new name would
 * clear everything else. Same list of fields v1 edits with.
 */
export function editBoxInput(info: BoxInfo): BoxCreateInput {
  const box = info.box;
  return {
    key: box.key,
    name: box.name,
    picture: box.picture,
    theme: box.theme,
    logo: box.logo,
    useCashLimit: box.useCashLimit,
    cashLimit: box.cashLimit,
    cashLimitMin: box.cashLimitMin,
    cashLimitCurrency: box.cashLimitCurrency,
    usePost: box.usePost,
    useWish: box.useWish,
    useCircleDraw: box.useCircleDraw,
    useNames: box.useNames,
    isPhoneRequired: box.isPhoneRequired,
    isArchived: box.isArchived,
  } as BoxCreateInput;
}
